/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  FetchSessionResponseFeatureDefaults,
  FetchSessionResponseFeatureDefaultsFromJSON,
  FetchSessionResponseFeatureDefaultsToJSON,
  Permission,
  PermissionFromJSON,
  PermissionToJSON,
  RegionDiscourseUrl,
  RegionDiscourseUrlFromJSON,
  RegionDiscourseUrlToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchSessionResponse
 */
export interface FetchSessionResponse {
  /**
   * The set of permissions granted to the user at login time, regardless of scope. This can be used to hide or disable UI elements that are not relevant to the user.
   * @type {Array<Permission>}
   * @memberof FetchSessionResponse
   */
  permissions?: Array<Permission>
  /**
   * The set of feature defaults granted to the user at login time, regardless of scope. This can be used to hide or disable UI elements that are completely irrelevant to the user.
   * @type {Array<FetchSessionResponseFeatureDefaults>}
   * @memberof FetchSessionResponse
   */
  featureDefaults?: Array<FetchSessionResponseFeatureDefaults>
  /**
   * The userKey of the successfully logged in user.
   * @type number
   * @memberof FetchSessionResponse
   */
  userKey?: number
  /**
   * The current role, via an actor, that the logged in user is acting as. If null, the current role will be considered 'parent'.
   * @type number
   * @memberof FetchSessionResponse
   */
  actingAs?: number
  /**
   * The current userName'.
   * @type string
   * @memberof FetchSessionResponse
   */
  username?: string
  /**
   * Links to the Discourse forum URLs associated with the regions the current user belongs to, based on their active role.
   * @type {Array<RegionDiscourseUrl>}
   * @memberof FetchSessionResponse
   */
  discourseUrls?: Array<RegionDiscourseUrl>
  /**
   * The user’s country of residence
   * @type string
   * @memberof FetchSessionResponse
   */
  countryOfResidence?: string
  /**
   * The user’s country of citizenship
   * @type string
   * @memberof FetchSessionResponse
   */
  countryOfCitizenship?: string
}

export function FetchSessionResponseFromJSON(json: any): FetchSessionResponse {
  return FetchSessionResponseFromJSONTyped(json, false)
}

export function FetchSessionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchSessionResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    permissions: !exists(json, 'permissions')
      ? undefined
      : (json['permissions'] as Array<any>).map(PermissionFromJSON),
    featureDefaults: !exists(json, 'featureDefaults')
      ? undefined
      : (json['featureDefaults'] as Array<any>).map(
          FetchSessionResponseFeatureDefaultsFromJSON
        ),
    userKey: !exists(json, 'userKey') ? undefined : json['userKey'],
    actingAs: !exists(json, 'actingAs') ? undefined : json['actingAs'],
    username: !exists(json, 'username') ? undefined : json['username'],
    discourseUrls: !exists(json, 'discourseUrls')
      ? undefined
      : (json['discourseUrls'] as Array<any>).map(RegionDiscourseUrlFromJSON),
    countryOfResidence: !exists(json, 'countryOfResidence')
      ? undefined
      : json['countryOfResidence'],
    countryOfCitizenship: !exists(json, 'countryOfCitizenship')
      ? undefined
      : json['countryOfCitizenship'],
  }
}

export function FetchSessionResponseToJSON(
  value?: FetchSessionResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    permissions:
      value.permissions === undefined
        ? undefined
        : (value.permissions as Array<any>).map(PermissionToJSON),
    featureDefaults:
      value.featureDefaults === undefined
        ? undefined
        : (value.featureDefaults as Array<any>).map(
            FetchSessionResponseFeatureDefaultsToJSON
          ),
    userKey: value.userKey,
    actingAs: value.actingAs,
    username: value.username,
    discourseUrls:
      value.discourseUrls === undefined
        ? undefined
        : (value.discourseUrls as Array<any>).map(RegionDiscourseUrlToJSON),
    countryOfResidence: value.countryOfResidence,
    countryOfCitizenship: value.countryOfCitizenship,
  }
}
